// extracted by mini-css-extract-plugin
module.exports = {"share":"Share_share__KkXRo","shareOpen":"Share_shareOpen__KRlaI"};